import React, { useEffect, useRef } from "react";
import { Row, Col, Input, Button, Modal } from "antd";
import Refresh from "../../../../assets/images/refresh.svg";
import CancelArrow from "../../../../assets/images/cancelArrow.svg";
import DefaultProductImage from "../../../../assets/images/no-image.svg";

const ProductWeightModal = ({
  displayManualQtyWeightInput,
  setDisplayManualQtyWeightInput,
  selectedProductInCart,
  cart,
  callGetWeightAPI,
  setProductWeightModalInput,
  onChangeTotalQuantity,
  setIsInputFocused,
  enterTotalQty,
  handleTotalQty,
}) => {
  const qtyInputRef = useRef(null);

  // When the popup opens, focus the quantity input and select its existing value
  // so the cashier can start typing immediately (e.g. "0.56") without having to
  // click next to the "0". Previously the cursor landed elsewhere and the first
  // keypress appended instead of replacing.
  useEffect(() => {
    if (displayManualQtyWeightInput) {
      const t = setTimeout(() => {
        const el = qtyInputRef.current?.input || qtyInputRef.current;
        if (el && typeof el.focus === "function") {
          el.focus();
          if (typeof el.select === "function") el.select();
        }
      }, 50);
      return () => clearTimeout(t);
    }
  }, [displayManualQtyWeightInput]);

  return (
    <Modal open={displayManualQtyWeightInput} closable={false} keyboard={false} footer={null} width="30%" centered styles={{ body: { padding: 10, backgroundColor: "#F3F4F9" } }}>
      <Row>
        <Col span={12} style={{ textAlign: "left", paddingLeft: "0.5vw" }}></Col>
        <Col span={12} style={{ textAlign: "right" }}>
          {/* <CloseOutlined
            onClick={() => {
              setProductWeightModalInput("");
              setDisplayManualQtyWeightInput(false);
            }}
            style={{ fontSize: "18px" }}
          /> */}
          <img
            src={Refresh}
            style={{ cursor: "pointer" }}
            onClick={() => {
              callGetWeightAPI(selectedProductInCart);
              setProductWeightModalInput("");
              // setDisplayManualQtyWeightInput(false);
            }}
          />
        </Col>
      </Row>

      <Row style={{ padding: "0 3.5% 0 3.5%" }} gutter={[8, 6]}>
        <Col span={24} style={{ paddingBottom: "1vh" }}>
          <img src={selectedProductInCart.imageurl || DefaultProductImage} style={{ height: "4.5vh" }} />{" "}
          <span style={{ fontWeight: 500, fontSize: "1rem" }}>{selectedProductInCart.name}</span>
        </Col>
        <Col span={24} style={{ paddingBottom: "1vh" }}>
          Sale Price: <span style={{ fontWeight: 500, fontSize: "0.9rem" }}>{selectedProductInCart.sunitprice}</span>
        </Col>
      </Row>

      <Row style={{ padding: "0 3.5% 0 3.5%" }} gutter={[8, 6]}>
        <Col span={24} style={{ paddingBottom: "2vh" }}>
          <Input
            className="productSearch sm-payment-search totalQtyInput"
            ref={qtyInputRef}
            autoFocus
            style={{
              borderRadius: "0.5vw",
              height: "8.3vh",
              borderRadius: "5px",
              textAlign: "right",
              fontWeight: "500",
              fontSize: "2.5em",
              borderColor: "#fff",
              color: "#2F3856",
              fontFamily: "Inter",
            }}
            // prefix={<span style={{ color: "#0F0718", fontWeight: "600" }}>Amount Tendered</span>}
            value={selectedProductInCart.weight}
            id="sm-amount-input"
            // type="number"
            onChange={(e) => {
              if (cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0) {
                onChangeTotalQuantity(e.target.value?.replace(/[^\d.]/g, ""));
              }
            }}
            readOnly={cart.items.length > 0 && Object.keys(selectedProductInCart).length > 0 ? false : true}
            placeholder="Enter Quantity"
            onFocus={(e) => {
              setIsInputFocused(true);
              // Select existing content so the first keypress replaces "0"
              // instead of producing e.g. "00.56".
              if (e && e.target && typeof e.target.select === "function") e.target.select();
            }}
            onBlur={() => {
              setIsInputFocused(false);
            }}
            onPressEnter={() => enterTotalQty("weight")}
          />
        </Col>
        <Col span={6}>
          <button id="sm-amount-button1" className="amt-dial-btn-production" onClick={() => handleTotalQty("1")}>
            1
          </button>
        </Col>
        <Col span={6}>
          <button id="sm-amount-button2" className="amt-dial-btn-production" onClick={() => handleTotalQty("2")}>
            2
          </button>
        </Col>
        <Col span={6}>
          <button id="sm-amount-button3" className="amt-dial-btn-production" onClick={() => handleTotalQty("3")}>
            3
          </button>
        </Col>
        <Col span={6}>
          <button className="amt-dial-btn-production" id="sm-amount-buttonRemove" onClick={() => handleTotalQty("x")}>
            <img src={CancelArrow} alt="back space" width={25} height={15} />
          </button>
        </Col>
        <Col span={6}>
          <button id="sm-amount-button4" className="amt-dial-btn-production" onClick={() => handleTotalQty("4")}>
            4
          </button>
        </Col>
        <Col span={6}>
          <button id="sm-amount-button5" className="amt-dial-btn-production" onClick={() => handleTotalQty("5")}>
            5
          </button>
        </Col>
        <Col span={6}>
          <button id="sm-amount-button6" className="amt-dial-btn-production" onClick={() => handleTotalQty("6")}>
            6
          </button>
        </Col>
        <Col span={6}>
          <button id="sm-amount-button." className="amt-dial-btn-production" onClick={() => handleTotalQty("clear")}>
            Clear
          </button>
        </Col>
        <Col span={18}>
          <Row gutter={[8, 6]}>
            <Col span={8}>
              <button id="sm-amount-button7" className="amt-dial-btn-production" onClick={() => handleTotalQty("7")}>
                7
              </button>
            </Col>
            <Col span={8}>
              <button id="sm-amount-button8" className="amt-dial-btn-production" onClick={() => handleTotalQty("8")}>
                8
              </button>
            </Col>
            <Col span={8}>
              <button id="sm-amount-button0" className="amt-dial-btn-production" onClick={() => handleTotalQty("9")}>
                9
              </button>
            </Col>
            <Col span={8}>
              <button id="sm-amount-button0" className="amt-dial-btn-production" onClick={() => handleTotalQty("0")}>
                0
              </button>
            </Col>
            <Col span={8}>
              <button id="sm-amount-button." className="amt-dial-btn-production" onClick={() => handleTotalQty("00")}>
                00
              </button>
            </Col>
            <Col span={8}>
              <button id="sm-amount-button00" className="amt-dial-btn-production" onClick={() => handleTotalQty(".")}>
                .
              </button>
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <button id="sm-amount-buttonEnter" className="amt-dial-btn-production-ent" onClick={() => enterTotalQty("weight")}>
            Enter
          </button>
        </Col>
      </Row>

      <Row style={{ padding: "3% 3.5% 0 3.5%" }} gutter={[8, 6]}>
        <Col span={12}>
          <Button
            onClick={() => {
              setProductWeightModalInput("");
              setDisplayManualQtyWeightInput(false);
            }}
            style={{ width: "100%", height: "7vh", borderRadius: "5px", backgroundColor: "#fff", color: "#2F3856" }}
          >
            Cancel
          </Button>
        </Col>
        <Col span={12}>
          <Button onClick={() => enterTotalQty("weight")} style={{ width: "100%", height: "7vh", borderRadius: "5px", backgroundColor: "#2F3856", color: "#fff" }}>
            Confirm
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default ProductWeightModal;
